//=============================================================================
// Contents   : HRDB
//              権限グループマスタ
//              GetAuthorityList
// Author     : RV奥村
// LastUpdate : 2023/04/12
// Since      : 2023/04/12
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";
/* ====== CSS ====== */
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
/* ====== Style ====== */
import { CODEDIFINITION_STORAGE, screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount, CFCreateApplyList,CFDateFormatEdit,CFStringDecodeJP,CFStringEncodeJP, CFJsonIgnore, CFCheckArrayData, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { useFieldArray, useForm } from "react-hook-form";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Title } from "01Pages/Common/UiParts/Title";
import { TableArray } from "02CommonUiParts/TableParts/TableArray";
import { ButtonIconCopyRegister } from "02CommonUiParts/ButtonParts/ButtonBase";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { SearchField } from "02CommonUiParts/OtherParts/SearchField";
import { CreateExcel } from "03CommonApiParts/CreateExcel";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { Table } from "02CommonUiParts/TableParts/Table";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
const CommonStyle = StyleCommon();//共通スタイルドコンポーネント
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ
/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= マスタテンプレート ========= */
export const MasterTemp = (props) => {
    const {listType,pageTitle,apiPath,headData,bodyData,getConfig, searchContentsLeft, searchContentsRight, updateConfig, editBodyData, editHeadData, updateApiPath, masterList, onClickRegister, listMode, defaultSearch,searchConfig} = props;
    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */
    const apiData = useProvideData();//APIデータ取得
    const location = useLocation();
    const navigate = useNavigate();//画面遷移用
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    // const keyList = Object.keys(showMaster)
    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue?.empJpnSrname + ' ' + userInfoValue?.empJpnName;//名前
    /* CODEDIFINITION_STORAGEからコード定義を取得 */
    const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
    var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const screenIdList = CFArrayFount(codeDefinitionValue,'code','screenId')?.list; //画面IDのリストを取得



    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newDataRow, setNewDataRow] = useState([]);//変更後データ格納用
    const [dataRow, setDataRow] = useState({//表示用データ格納用(変更後)
        applyList:[],
        aplySrtDate:'',
        list:[]
    });
    const [pageMode, setPageMode] = useState('list');//list: 一覧、edit:編集、registerConfirm:登録確認、updateConfirm:更新確認
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    const [bodyDataNew, setBodyDataNew] = useState(); //body設定
    const [editBodyDataNew, setEditBodyDataNew] = useState(); //editBody設定
    const [master, setMaster] = useState();//マスターデータ格納用
	const [dragIndex, setDragIndex] = useState();
	const [level, setLevel] = useState(); //　ドラッグした部署レベル保存用
    const [searchFlg, setSearchFlg] = useState(false); // 検索中ならtrue
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue,watch,control,handleSubmit,formState: { errors } } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        shouldUseNativeValidation: false,
        shouldUnregister: false,
        escalationCode:false
    });
    const { fields, append, remove, replace } = useFieldArray(
		{
			control,
			name: `payload.list`
		}
	);

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        /* APIデータ取得 */
        // console.log(location)
        if(location?.state?.type === 'update' || location?.state?.type === 'register'){
            (async() => {
                setDataRow(location.state.old);
                setNewDataRow(location.state.new);
                setValue('payload.aplySrtDate',location.state.new.aplySrtDate);
                setValue('payload.list', location.state.new.list);
                setPageMode(location.state.type === 'update' ? 'edit': 'register');
                await getMaster(location.state.new.aplySrtDate, masterList);
                setLoading(true);
            })()
        }else{
            (async() => {
                await getData();
                await getMaster(null, masterList);
                setLoading(true);
            })()
        }
        // eslint-disable-next-line
    },[]);
    /* ====== マスタの取得処理 ====== */
    const getMaster = async(date,list) => {
        if(!(list?.length > 0)){
            createBodyData();
            return;
        }
        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date;
        key.mstList = list;

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const masterList = [];
                data.forEach((item)=>{
                    const masterSmallList = [];
                    item.list.forEach((master)=>{
                        masterSmallList.push({
                            value:master.value,
                            label:CFStringDecodeJP(master.label,base64Swicth)
                        });
                    });
                    masterList.push({
                        code:item.code,
                        name:item.name,
                        list:masterSmallList
                    })
                });
                createBodyData(masterList);
                setMaster(masterList);

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
    /* ====== マスターデータを元にbodyDataを表示 ====== */ 
    const createBodyData = (masterData) =>{
        /* マスタデータがある場合 */
        if(masterList){
            const bodyDataNewList = [];
            bodyData.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'master'){

                    object.master = CFArrayFount(masterData,'code',body.master);

                }else if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);

                }
                bodyDataNewList.push(object);
            })
            setBodyDataNew(bodyDataNewList);

            const editBodyDataNewList = [];
            editBodyData?.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'master'){

                    object.master = CFArrayFount(masterData,'code',body.master);

                }else if(body.masterType === 'codeMaster'){

                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                    
                };
                editBodyDataNewList.push(object);
            });
            setEditBodyDataNew(editBodyDataNewList);

        /* コード定義のみの場合 */
        }else{
            const bodyDataNewList = [];
            bodyData.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                };
                bodyDataNewList.push(object);
            })
            setBodyDataNew(bodyDataNewList);

            const editBodyDataNewList = [];
            editBodyData?.forEach((body) =>{
                const object = {...body};
                if(body.masterType === 'codeMaster'){
                    object.master = CFArrayFount(codeDefinitionValue,'code',body.master);
                };
                editBodyDataNewList.push(object);
            });
            setEditBodyDataNew(editBodyDataNewList);
        };
    }
    const getData = async(date) =>{
        /* スナックバー表示 */
        setSnackbarMessage({      
            ...snackbarMessage,
            open:false,
            message:null,
            param1:null,
            level:null,
            type:null,
            afterFunction:null
        });
        /* 検索フラグをfalse */
        setSearchFlg(false);
        /* プログレスバー表示 */
        setProgress(true);
		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
	
		/* キー */
		key[getConfig.key] = date ? date : null;

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};
        
        /* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                /* 適用開始日リストの作成　*/
                const createApplyList = CFCreateApplyList(data.aplySrtDateList,'aplySrtDate');
                let aplySrtDate;
                let otpDate = '';
                /* リストデータの作成 */
                const list = [];
                data[getConfig.payload.name].forEach((data1)=>{
                    getConfig.payload.list.forEach((listItem1)=>{
                        if(listItem1.list){
                            data1[listItem1.name].forEach((data2,index)=>{
                                const object = {};
                                listItem1.list.forEach((listItem2)=>{
                                    let value1;
                                    let value2;
                                    if(listItem2.base64){
                                        value1 = CFStringDecodeJP(data2[listItem2.name],base64Swicth);
                                    }else{
                                        value1 = data2[listItem2.name];
                                    };  
                                    if(listItem2.base642 === true){
                                        value2 = data2[listItem2.name2] ? CFStringDecodeJP(data2[listItem2.name2],base64Swicth) : undefined;
                                    }else{
                                        value2 = data2[listItem2.name2];
                                    }
                                    object[listItem2.name] = value2 ? value1 + ' ' + value2 : value1;
                                });
                                object.id = index;
                                list.push(object);
                            });
                        }else{
                            if(listItem1.name === 'aplySrtDate'){
                                aplySrtDate = data1[listItem1.name];
                            }else if(listItem1.name === 'otpDate'){
                                otpDate = CFDateFormatEdit(data1[listItem1.name]);
                            }
                        };
                    });
                });

                
                const payload = {
                    applyList:createApplyList.applyList,
                    aplySrtDate:aplySrtDate,
                    otpDate:otpDate,
                    list:list
                };
                setDataRow(payload);
                setNewDataRow(payload);
                setValue('payload.aplySrtDate',payload.aplySrtDate);
                setValue('payload.otpDate',payload.otpDate);
                setValue('payload.list', payload.list);
                if(createApplyList.futureList[0] === aplySrtDate){
                    if(CFArrayFount(payload.applyList, 'aplyFlag', true).value === createApplyList.futureList[0]){
                        /* 選択された適用開始日が、適用開始日リスト内で一番大きい日付&適用中であれば、コピーして登録ボタン、編集ボタンを表示、削除して登録ボタンを表示　*/
                        setPageMode('futureList');
                    }else{
                        /* 選択された適用開始日が、適用開始日リスト内で一番大きい日付&適用中でなければ、削除ボタン、コピーして登録ボタン、編集ボタンを表示 */
                        setPageMode('futureDeleteList');
                    }
                }else if(createApplyList.futureList.some(day => day === aplySrtDate)){
                    /* 一番最新の適用日が現在適用中以降の日付であれば、削除ボタン、コピーして登録ボタンは非表示、編集ボタンは表示　*/
                    setPageMode('list');
                }else if(aplySrtDate === CFArrayFount(createApplyList.applyList, 'aplyFlag', true).value){
                    setPageMode('list');
                }else{
                    /* 現在適用中を除いた過去の日時であれば全て非表示 */
                    setPageMode('pastList');
                }

			}else{//APIリクエスト結果 = 異常
                setPageMode('pastList');
                setValue('payload.list', []);
			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
		});

    };
    /* === 更新処理 === */
    const updateData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト*/
        const handlingInformation = {};
        var key = {};
        const payload = [];

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'UPDATE';

      
        /* キーをセット */
        const keyObject = {};
        updateConfig.key.forEach((k)=>{
            keyObject[k] = newDataRow[k];
        });
        key = keyObject;

        confirm.data.forEach((cnf,i)=>{
            // 削除されたものならプッシュしない
            if(cnf.dataType === "delete"){
                return;
        }
            /* ペイロードをセット */
            const payloadObject = {};
            updateConfig.payload.forEach((item)=>{
                let value = cnf[`${item.name}New`] ? cnf[`${item.name}New`]: cnf[item.name];
                if(value === undefined || value === '' || value === '未入力'){
                    payloadObject[item.name] = null;
                }else if(item.type === String){
                    value = item.name2 ? value.split(' ')[0] : value;
                    if(item.base64){
                        payloadObject[item.name] = CFStringEncodeJP(value,base64Swicth);   
                    }else{
                        payloadObject[item.name] = value;
                    }
                }else if(item.type === Boolean){
                    payloadObject[item.name] = value === 'true' ? true : value === 'false' ? false : value;
                }
            });
            
            /* objectを格納 */
            payload.push(payloadObject);
        });
        const apiPath = updateApiPath;
        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key, payload: payload };
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);

			/* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                navigate('/common/completion', {
                    state:{
                        title: `${CFArrayFount(screenIdList,'value',CFArrayFount(screenMaster,'path',location.pathname).id).label}編集完了`, 
                        message: screenDisplayMessage('CMNI004'), //データの更新が完了しました。
                        button:[
                            {name: '一覧画面へ戻る', path: location.pathname}
                        ]
                        },
                    replace:true
                 },);

            }else{//APIリクエスト結果 = 異常

                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });

            };
        });

    }
    const deleteData = async() => {
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/master/deletedepartment';	//API Path
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'DELETE';

        /* キー */
        key.aplySrtDate = getValues('payload.aplySrtDate');

        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key:key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);

            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                navigate('/common/completion', {
                    state:{
                        title: '部署マスタメンテ削除完了', 
                        message: screenDisplayMessage('CMNI005'), //データの削除完了
                        button:[
                            {name: '一覧画面へ戻る', path:'/master/department/list'},
                        ]
                    },
                    replace:true
                });
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            };
        });
    };
    /* ====== 削除ボタンを押した時の処理 ====== */
    const onClickRight = () =>{
        /* 変更後のデータをnewDataに入れておく */
		setNewDataRow(getValues('payload'));
        /* deleteモードに変更 */
		setPageMode('deleteConfirm');
        /* dataRowにリセット */
        setValue('payload.list',dataRow.list);
    }
    /* ====== 適用日ボタン押下 ====== */
    const onChangeApply = (event) => {
        getData(event.target.value);
    } ;
    /* ====== コピーして登録ボタンを押下 ====== */
    const onClickCopyRegist = () =>{
        /**
         * 1.出力日と本日を比較
         * 2.出力日<=本日なら、本日+1日を適用開始日にセットする
         * 3.本日<出力日なら出力日を適用開始日にセットする
         * 4.pageModeをregisterにする
         **/
        /* ====== 適用日登録時日付取得 ====== */
        var date = new Date();//今日の日付を取得
        const aplySrtDate = new Date(getValues('payload.otpDate'))//出力日を取得
        if(aplySrtDate.getTime() <= date.getTime()){
            date.setDate(date.getDate() + 1);
        }else{
            date = aplySrtDate; // 出力日を代入
        };
        /* yyyy-mm-ddの形に変える */
        let year = aplySrtDate.getFullYear();//年を取得
        let month = ('00' + (aplySrtDate.getMonth()+1)).slice(-2)//月を取得
        let day = ('00' + (aplySrtDate.getDate())).slice(-2);//日を取得
        let today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する

        /*　日付のセット */
        setValue('payload.aplySrtDate',today);

        /* pageModeのセット */
        setPageMode('register');
    }
    /* ====== 出力日を変更した時の処理 ====== */
    const onChangeOtpDate = (event) =>{
        getData(event.target.value);
    };
    /* === エクセル出力ボタン押下時の処理 === */
    const onClickExcel = (excelTitle) => {
        const afterFunc = async() =>{
            /* プログレスバー表示 */
            setProgress(true);
            /* リクエスト先 */
            const apiPathExcel = '/common/registeroutputrecord';
            /* リクエスト*/
            const handlingInformationExcel = {};
            const keyExcel = {};
            
            /* 操作情報 */
            handlingInformationExcel.hndEmpMailAdrs = userInfoValue.mail; 
            handlingInformationExcel.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
            handlingInformationExcel.sreId = screenId;
            handlingInformationExcel.hndId = 'GET';
            /* キー */
            keyExcel.dlFileId = screenId;
            keyExcel.dlCdt = [];
            /* 検索値の取得 */
            let searchData = getValues('search');

            Object.keys(searchData).forEach((sKey)=>{
                const object = {};
                object.sarCd = sKey;
                object.sarValue = searchData[sKey] ? CFStringEncodeJP(searchData[sKey],base64Swicth) : null;
                keyExcel.dlCdt.push(object);
            });
            /* リクエストパラメータ */
            const apiBodyExcel = {handlingInformation:handlingInformationExcel, key:keyExcel};

            await apiData.getDataPost(apiPathExcel, apiBodyExcel, (excelResult) => {
                /* プログレスバー非表示 */
                setProgress(false);
                if(excelResult.isSuccessed) {//APIリクエスト結果 = 正常
                    const data = excelResult.responseData.data.payload;
                    const excelConfig = [];
                    data.headerList.forEach((head)=>{
                        excelConfig.push({
                            id:head.id,
                            name:CFStringDecodeJP(head.name,base64Swicth),
                            type:'normal'
                        })
                    });
                    const dataEdit = [];
                    data.bodyList.forEach((body)=>{
                        const object = {};
                        Object.keys(body).forEach((item)=>{
                            object[item] = CFStringDecodeJP(body[item],base64Swicth);
                        });
                        dataEdit.push(object);
                    });
                    
                    /* エクセル出力 */
                    CreateExcel(excelTitle,excelConfig,dataRow);

                }else{//APIリクエスト結果 = 異常
                    /* スナックバー表示 */
                    setSnackbarMessage({      
                        ...snackbarMessage,
                        open:true,
                        message:excelResult,//APIによるエラー
                        type: 1,//APIエラー時:1,それ以外:2 
                        level:'error',//エラースナックバー
                    })
                };
            });
	    }
        /* 更新確認ダイアログ表示 */
        setDialogMessage({      
            ...dialogMessage,
            open: true,
            message: 'CMNC002',//メッセージID(commonFunctionより対象のメッセージ)
            afterFunc:afterFunc,
            pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
        });
    }
                    
    /* === 一括登録ボタン押下時の処理 === */
    const onClickBulkUpdate = (path) => {
        navigate(path);
    };
    const reset = () => {
        setValue('search.sarLiteral', '');
    }

    /* === 検索ボタン押下時の処理 === */
    const onClickSearch = (e) => {
        if(!searchConfig) return;
        if(e.search.sarLiteral === ''){
            // setPageMode('edit');
            setSearchFlg(false);
            setNewDataRow(dataRow);
            replace(dataRow.list);
            return;
        }else{
        setSearchFlg(true)};
        const literalList = e.search.sarLiteral.split(/[ 　]/);
        const cpyDataRow = JSON.parse(JSON.stringify(newDataRow));
        const filterResult = [];
        /**
         * データを１行ずつ取り出す
         * 検索文字を１つずつ取り出す
         * 検索対象のいずれかの値に一致していたらOK
         * 検索文字が全てOKだったらfiterResultに入れる
         * 一致していなかったら次のデータを見る
         * fiterResultをsetする
         */
        // データを１行ずつ見ていく
        cpyDataRow.list.forEach((row) => {
            // 配列にプッシュするかを管理するフラグ
            let pushRowFlag = true;
            // 検索文字配列をループ
            literalList.forEach((literal) => {
                // 文字列が見つかったかどうかを管理するフラグ
                let findLiteralFlag = false;
                // 検索対象のコードを１行ずつ見ていく
                searchConfig.payload.forEach((conf) => {
                    // const confName = conf.name;
                    // データの値を取得
                    let rowValue;
                    if(conf.master){
                        // マスタから変換する場合は、conf.masterに一致するマスタリストを取得
                        const masterInfo = CFArrayFount(master,'code',conf.master);
                        // マスタリストからデータの値に一致するオブジェクトのラベルを取得
                        rowValue = CFArrayFount(masterInfo.list, 'value', row[conf.name]) ? CFArrayFount(masterInfo.list, 'value', row[conf.name]).label : null;
                    }else{
                        rowValue = row[conf.name];
                    }
                    if(rowValue !== null){
                        // 検索対象の値が1回でも文字が一致したらflagをtrueにする
                        if(rowValue?.toString().toUpperCase().indexOf(literal.toUpperCase()) !== -1){
                            findLiteralFlag = true;
                        }
                    }
                });
                // 検索対象の値がどれも検索文字にヒットしなかった場合は配列にpushしないフラグを立てる(AND条件)
                if(findLiteralFlag === false){
                    pushRowFlag = false;
                }
            });
            // 配列にプッシュするフラグが立ったままなら配列にプッシュする
            if(pushRowFlag){ 
                filterResult.push(row);
            }
        });
        setNewDataRow(cpyDataRow, {list:filterResult});
        replace(filterResult);
    }
    const checkUnderbarType = () =>{
        let result;
        switch(pageMode){
            case 'list':
                result = 'edit'; // 一覧表示時は編集ボタン
            break;
            case 'futureList':
                result = 'edit';// 未来適用開始日選択時は編集・削除
            break;
            case 'futureDeleteList':
                result = 'editDelete';// 未来適用開始日選択時は編集・削除
            break;
            case 'pastList':
                result = '';// 過去適用開始日は何もなし
            break;
            case 'edit':
                result = 'confirmCancel';// 編集時は確認・キャンセル
            break;
            case 'register':
                result = 'confirmCancel';// 登録時は確認・キャンセル
            break;
            case 'updateConfirm':
                result = 'completeBack';//　更新の確認時は完了・戻る
            break;
            case 'deleteConfirm':
                result = 'completeBack';// 削除確認時は完了・戻る
            break;
            case 'registerConfirm':
                result = 'completeBack';// 登録確認時は完了・戻る
            break;
            // case 'list':
            
            // break;
            // case 'list':
            
            // break;
            default:
                result = 'edit';
            break;
        }
       return result;
    };
    /* === データ確認処理=== */
    const checkEditData = (data) =>{
        /* dataRowのコピー(階層が深いのでこの形式) */
        // var oldData = JSON.parse(JSON.stringify(dataRow.list));
        // var newData = JSON.parse(JSON.stringify(newDataRow.list));
        var oldData = [];
        var newData = [];
        const keys = [];
        updateConfig.payload.forEach((item)=>{
            keys.push(item.name);
        })
        /* 配列データの変更を確認して調整する処理 */
        CFCheckArrayData(dataRow.list,getValues('payload.list'),oldData,newData,keys);
        /* 変更点がない場合　*/
        if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
            /* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW004',
                type: 2,//APIエラー時:1,それ以外:2 
            });
        }else{
        /* 変更点がある場合　*/
            /* keyの抽出 */
            const keys = Array.isArray(oldData) ? (Object.keys(oldData[0]).length > 0 ? Object.keys(oldData[0]) : Object.keys(newData[0])):Object.keys(oldData);
            /* 変更があればchangeFlagをtrueにする */
            let changeFlags = checkChangeFlag(oldData,newData, keys);
            let changeData = confirmChange(changeFlags,oldData,newData, keys);
            setConfirm(
                {
                    flags:changeFlags,
                    data:changeData
                }
            );
            /* 変更後データの格納 */
            setNewDataRow(data);
            /* 確認モードに変更　*/
            pageMode === 'register' ? setPageMode('registerConfirm') : setPageMode('updateConfirm');
            // /* ペイロードのリセット */
            reset();
        };
    // };
    }
    /* === 確認ボタンを押した時の処理=== */
    const onClickSubmit = (data) =>{
        if(pageMode === 'register'){
            const oldAplyDate = new Date(dataRow.aplySrtDate);
            const newAplyDate = new Date(getValues('payload').aplySrtDate);
            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            /* 登録しようとした適用日が今日よりも前 */
            if(today > newAplyDate){
               /* スナックバー表示 */
               setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW001',
                type: 2,//APIエラー時:1,それ以外:2 
                level:'error'//エラースナックバー
                })
            }
            else if(dataRow.applyList.some(e=>new Date(e.value).getTime() === newAplyDate.getTime())){
                /* スナックバー表示 */
                setSnackbarMessage({      
                 ...snackbarMessage,
                 open:true,
                 message:'CMNW006',
                 type: 2,//APIエラー時:1,それ以外:2 
                 level:'error'//エラースナックバー
                 })
             }
            /* 登録しようとした適用日がコピーしたデータよりも前 */
            else if( oldAplyDate > newAplyDate ){
                /* コピーしたデータが削除されても良いかを確認　*/
                const afterFunc = () =>{
                    /* データ確認処理　*/
                    checkEditData(data.payload);
                }
                /* 確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open:true, 
                    message:'CMNC003',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterFunc,
                    pattern: 2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }else{
                /* データ確認処理　*/
                checkEditData(data.payload);
            };
        }else{
            /* データ確認処理　*/
            checkEditData(data.payload);
        }

    };
    /* ===　キャンセル・戻るボタンを押した時の処理=== */
    const onClickLeft = () => {
        /* 編集モード時(キャンセルボタン押下時の処理) */
        if(pageMode === 'edit'){
            /* dataRowのコピー(階層が深いのでこの形式) */
            const oldData = [];
            const newData = [];
            const keys = [];
            updateConfig.payload.forEach((item)=>{
                keys.push(item.name);
            })
            /* 配列データの変更を確認して調整する処理 */
            CFCheckArrayData(dataRow.list,newDataRow.list,oldData,newData,keys);

            /* キャンセルした場合(OKボタン押下)の処理 */
            const afterCancel = () =>{
                /* 値のリセット */
                reset();
                setConfirm({});
                navigate(location.pathname, {state:null});
                /* データ取得 */
                getData(dataRow.aplySrtDate);
            }
            /* データの変更がなければ、編集モードを終了 */
            if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
                afterCancel();
            }
            /* データの変更があれば、確認ダイアログを表示 */
            else{
                /* 更新確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterCancel,
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }
        }else if(pageMode === 'register'){

            /* キャンセルした場合(OKボタン押下)の処理 */
            const afterCancel = () =>{
                /* 値のリセット */
                reset();
                navigate(location.pathname, {state:null});
                /* データ取得 */
                getData(dataRow.aplySrtDate);
            }

            /* 更新確認ダイアログ表示 */
            setDialogMessage({      
                ...dialogMessage,
                open: true,
                message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                afterFunc:afterCancel,
                pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
            });

        }        
        /* 確認モード時(戻るボタン押下時の処理) */
        else{
            /* 編集モードに戻す */
            setPageMode(pageMode === 'updateConfirm' ? 'edit' : 'register');
            /* 変更後データをpayloadにセット */
            setValue('payload',newDataRow);
            /* stateを空にする */
            setConfirm({});
        }
        
    };
    /* === 編集・完了ボタンを押した時の処理=== */
    const onClickCenter = () =>{
        if(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList' ){
            
            /* ソートリセットダイアログ表示 */
            searchFlg ? 
                setDialogMessage({
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC004',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:() => {
                        onClickSearch({search:{sarLiteral: ''}});
                        setValue('search.sarLiteral', '');
                        setPageMode('edit');
                    },
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                })
            :setPageMode('edit');
            
        }else if(pageMode === 'updateConfirm'){
            /* プログレスバー表示 */
            setProgress(true);
            updateData();
        }else if(pageMode === 'deleteConfirm'){
            /* プログレスバー表示 */
            setProgress(true);
            deleteData();
        }else if(pageMode === 'registerConfirm'){
            /* プログレスバー表示 */
            setProgress(true);
            updateData();
        };
    };
	/* === ドラッグ開始処理 === */
	const dragStart = (event,index) =>{
		setDragIndex(index);
		event.dataTransfer.effectAllowed = "move";
        var lv = 0;//部署のレベル、４：G・３：室・２：部、１：本部
        // var headStr = getValues(`payload.list.${index}.headquartersName`);
        // var roomStr = getValues(`payload.list.${index}.roomName`);
        // var partStr = getValues(`payload.list.${index}.partName`);
        if(getValues(`payload.list.${index}.dptGpOrd`) !== null){
            lv = 4;
            // concatStr = headStr + roomStr + partStr;
        }else if(getValues(`payload.list.${index}.dptRomOrd`) !== null){
            lv = 3;
            // concatStr = headStr + roomStr;
        }else if(getValues(`payload.list.${index}.dptPartOrd`) !== null){
            lv = 2;
            // concatStr = headStr;
        }else if(getValues(`payload.list.${index}.dptHqOrd`) !== null){
            lv = 1;
            // concatStr = '';
        }
        setLevel(lv);
	}
	 /* === ドラッグ中処理 === */
	const dragEnter = (index) =>{
		
	}
	/* === ドラッグ終了処理 === */
	const dragEnd = (index) => {
		/* 同じ場所にドロップしている時は何もしない */
		if(index === dragIndex) return;
        /* ドラッグ先が同じ部署レベルか判断 */
        var lv = 0;//部署のレベル、４：G・３：室・２：部、１：本部
        const hqOrd = getValues(`payload.list.${index}.dptHqOrd`);
        const partOrd = getValues(`payload.list.${index}.dptPartOrd`);
        const romOrd = getValues(`payload.list.${index}.dptRomOrd`);
        const gpOrd = getValues(`payload.list.${index}.dptGpOrd`);
        if(gpOrd !== null){
            lv = 4;
            // concatStr = headStr + roomStr + partStr;
        }else if(romOrd !== null){
            lv = 3;
            // concatStr = headStr + roomStr;
        }else if(partOrd !== null){
            lv = 2;
            // concatStr = headStr;
        }else if(hqOrd !== null){
            lv = 1;
            // concatStr = '';
        }
        /* 同じレベルでなければ何もしない */
        if(lv !== level) return;
        /* 現在のpayloadデータを取得 */
		const data = getValues('payload.list');

        const targetList = [
            "dptHqOrd",
            "dptPartOrd",
            "dptRomOrd",
            "dptGpOrd"
        ];

        /* 更新対象のオブジェクトIDを取得 */
        const updateTarget = targetList[lv-1];//lv=４：dptGpOrd(G)・lv=３：dptPartOrd(室)・lv=２：dptRomOrd(部)、lv=１：dptGpOrd(本部)

        /* ドラッグ元データ取得 */
        const dragData = data[dragIndex];
        /* ドラッグ先データ取得 */
        const putData = data[index];
        /* 編集後データ格納用 */
        let editData = [];
        
        /**
         * 上位の部署順が異なればそのまま返す 
         * 本部順→部順→室順の順番で番号が同じかどうか確認
         **/
        let returnFlag = false;
        for( let i = 1; i < lv ; i++){// iは1からスタート(lvが1~4のため)、lv以上になれば終了(lvの１つ上のレベルまで確認するため)
            const target = targetList[i-1];
            if(dragData[target] !== putData[target]){
                returnFlag = true;
            }
        }

        if(returnFlag){
            editData = data;
        }else{
            /* ドラック元>ドラッグ先の時はドラッグ先の表示順<=表示順<ドラッグ元の表示順となるものを+1する */
            if(dragData[updateTarget] > putData[updateTarget]){
                editData = data.map((obj, index) => {

                    /* ドラッグ元の表示順と一致するデータは、ドラッグ先の表示順に変更する */
                    if(obj[updateTarget] === dragData[updateTarget]){
                        return {...obj, [updateTarget]: putData[updateTarget]};
                    /* ドラッグ先の表示順<=表示順<ドラッグ元の表示順の場合は表示順を+1する */
                    }else if((putData[updateTarget] <= obj[updateTarget]) && (obj[updateTarget] < dragData[updateTarget])){
                        return {...obj, [updateTarget]: Number(obj[updateTarget]) + 1}
                    /* 上記に該当しないものはそのまま */
                    }else{
                        return obj;
                    }
                });
                // setValue('payload.list', editData);
            /* ドラック元<ドラッグ先の時はドラッグ先の表示順<表示順<=ドラッグ元の表示順となるものを-1する */
            }else{
                editData = data.map((obj, index) => {
                
                    /* ドラッグ元の表示順と一致するデータは、ドラッグ先の表示順に変更する */
                    if(obj[updateTarget] === dragData[updateTarget]){
                        return {...obj, [updateTarget]: putData[updateTarget]};
                    /* ドラッグ先の表示順<表示順<=ドラッグ元の表示順の場合は表示順を+1する */
                    }else if((dragData[updateTarget] < obj[updateTarget]) && (obj[updateTarget] <= putData[updateTarget])){
                        return {...obj, [updateTarget]: Number(obj[updateTarget]) - 1}
                    /* 上記に該当しないものはそのまま */
                    }else{
                        return obj;
                    }
                });
                // setValue('payload.list', editData);
            }
        }
        /* 表示順で並べ替えたものをsetする */
        setValue(`payload.list`,  editData.sort((a,b) => {
            if(Number(a.dptHqOrd) > Number(b.dptHqOrd)) return 1;
            if(Number(a.dptHqOrd) < Number(b.dptHqOrd)) return -1;

            if(Number(a.dptPartOrd) > Number(b.dptPartOrd)) return 1;
            if(Number(a.dptPartOrd) < Number(b.dptPartOrd)) return -1;

            if(Number(a.dptRomOrd) > Number(b.dptRomOrd)) return 1;
            if(Number(a.dptRomOrd) < Number(b.dptRomOrd)) return -1;

            if(Number(a.dptGpOrd) > Number(b.dptGpOrd)) return 1;
            if(Number(a.dptGpOrd) < Number(b.dptGpOrd)) return -1;

            return 0;
        }))
	}
    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    
    /* ====== 適用日データ ====== */
    // 適用開始日のリスト又はラベル
	const applyDateTableConfig = [
        {
			id:'row1', 
			label:'適用開始日', 
			list:[
				{
					name:'aplySrtDate',
					type:(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList' || pageMode === 'pastList') ? 'applySelect' : 'dateLabel',
					applyList: 'applyList',
					clickType: 'base',
				}
			]
        }
    ];
    // datePickerの適用開始日
	const applyDateTableRegConfig = [
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'aplySrtDate',type:'date',pattern:'date'},
            ]
        }
    ];
    // 出力日と適用開始日のリスト
    const outputApplyDateTableConfig = [
        {
			id:'row0', 
			label:'出力日', 
			list:[
                {name:'otpDate',type:'date',onChange:onChangeOtpDate}
			]
        },
        {
			id:'row1', 
			label:'適用開始日', 
			list:[
				{
					name:'aplySrtDate',
					type: 'applySelect',
					applyList: 'applyList',
					clickType: 'base',
				}
			]
        }
    ];

    
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <CommonStyle.GdivTitleWrapper>
            <Title text={pageTitle + (pageMode.includes('Confirm') ? '確認' : pageMode === 'edit' ? '編集' : 'メンテ')} borderBottom='none'/>
            </CommonStyle.GdivTitleWrapper>
            {/* 確認文言 */}
            <CommonStyle.GdivConfirmText mode={pageMode}/>
            <CommonStyle.GdivPageContentsWrapper>
                <CommonStyle.GdivSubTitleWrapper>
                    <label style={{marginRight: '10px'}}>適用開始日情報</label>
                    {/* 一覧表示モードの時だけ表示 */}
                    { (pageMode === 'futureList' || pageMode === 'futureDeleteList') && editBodyData &&
                    <ButtonIconCopyRegister onClick = {()=> onClickCopyRegist()}/>}
                </CommonStyle.GdivSubTitleWrapper>
                <LeftTitleTable
                className='baseText'
                register={register}
                payload='payload'
                errors={errors}
                dataRow={newDataRow}
                tableConfig={listType === 'deptMaster' && (pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList' || pageMode === 'pastList') ?
                        outputApplyDateTableConfig  // 部署マスタでページタイプがlist,fureList,pastListの時は出力日と適用開始日を表示
                    :pageMode === 'register' ?
                        applyDateTableRegConfig // 登録モードの時は入力可能な適用開始日を表示
                    : applyDateTableConfig  // 編集モード、確認モードの時は日付のラベルを表示
                }
                onChangeApply={onChangeApply}
                />
                <CommonStyle.GdivSubTitleWrapper style={{marginBottom:'8px', marginTop: '10px'}}>
                    {pageTitle + '情報'}
                </CommonStyle.GdivSubTitleWrapper>                
                <form onSubmit={handleSubmit(onClickSearch)}>
                    {searchContentsLeft || searchContentsRight ? 
                        // 検索欄
                        <SearchField
                        register={register}
                        payload='search'
                        payloadData={getValues('search')}
                        search={searchContentsLeft}
                        search01={searchContentsRight}
                        reset={reset}
                        headCells={headData}
                        onClickExcel={onClickExcel}
                        onClickBulkUpdate={onClickBulkUpdate}
                        setValue={setValue}
                        editMode={pageMode === 'register' || pageMode === 'registerConfirm' || pageMode === 'edit' || pageMode === 'updateConfirm' ||  pageMode === 'confirm'}
                        errors={errors}
                        // setDisplayData={setDisplayData}
                        dataRow={newDataRow}
                        defaultSearch={defaultSearch}
                        />
                        :
                        ''
                    }
                </form>
                <form  onSubmit={handleSubmit(onClickSubmit)}>
                    {(pageMode !== 'registerConfirm' && pageMode !== 'updateConfirm') ?
                        <TableArray
                            paperStyle={{ maxHeight: listType === 'deptMaster'? 'calc(100vh - 395px)' : 'calc(100vh - 320px)' }}
                            headCells={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList' || pageMode === 'pastList' || pageMode === 'deleteConfirm') ?  headData : editHeadData} //ヘッダの設定情報
                            bodyCells={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList' || pageMode === 'pastList' || pageMode === 'deleteConfirm') ? bodyDataNew : editBodyDataNew} //ボディの設定情報
                            dataRow={newDataRow.list} //表示データ
                            payloadData={watch('payload').list}
                            errors={errors}
                            payload='payload'
                            listMode={listMode}
                            register={register}
                            fieldsList={fields}
                            tableType={pageMode === 'edit' ? 'moveAll' : ''}
                            append={append}
                            remove={remove}
                            hoverEffect={true}
                            payloadCategory='list'
                            showBottom={true}
                            notShowSearchNumber={pageMode === 'edit' || pageMode === 'register'}
                            changeOrder={pageMode === 'edit'}
                            setValue={setValue}
                            getValues={getValues}
                            editMode={pageMode === 'edit' || pageMode === 'register'}
                            onClickRegister={onClickRegister}
                            oldData={dataRow}
                            pageType={pageMode === 'edit' ? 'update' : 'register'}
                            dragStart={dragStart}
                            dragEnter={dragEnter}
                            dragEnd={dragEnd}
                        />
                    :
                        <Table
                            paperStyle={{ maxHeight: 'calc(100vh - 365px)' }}
                            headCells={headData} //ヘッダの設定情報
                            bodyCells={bodyDataNew} //ボディの設定情報
                            payload='payload'
                            register={register}
                            errors={errors}
                            // payloadData={getValues('payload.list')}
                            dataRow={confirm.data} //表示データ
                            notShowSearchNumber={true}
                            payloadCategory={'list'}
                            changeFlags={confirm?.flags}
                        /> 
                    }
                    {/* アンダーバー */}
                    {listType !== 'list' ? //編集しないタイプの一覧では表示しない
                        <Underbar
                            type={editBodyData ? checkUnderbarType() : ''} //react-hook-form
                            onClickLeft={()=>onClickLeft()}//キャンセル・戻るボタン押下時の処理
                            // onClickCenter={(event) => pageMode ? 1 : onClickEdit()}//編集ボタン押下時の処理
                            onClickCenter={()=>onClickCenter()}//編集ボタン・確認ボタン押下時の処理
                            onClickRight={()=>onClickRight()}//編集ボタン・確認ボタン押下時の処理
                        />
                    :<></>}
                </form>
            </CommonStyle.GdivPageContentsWrapper>
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/> 
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
                />
            
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 


